export let NoteType;(function (NoteType) {NoteType["NextPayment"] = "nextPayment";NoteType["Processing"] = "processing";NoteType["Ended"] = "ended";NoteType["Paused"] = "paused";NoteType["Attention"] = "attention";NoteType["Text"] = "text";})(NoteType || (NoteType = {}));








export let PaymentMethod;(function (PaymentMethod) {PaymentMethod["Card"] = "Card";PaymentMethod["Paypal"] = "Paypal";})(PaymentMethod || (PaymentMethod = {}));

















export function isTextNote(data) {
  return Boolean(data?.text);
}

export function isNextPaymentNote(data) {
  return Boolean(data?.paymentMethod && data?.date);
}